<template>
  <n-input v-bind="$attrs" :value="value" :type="type" @input="$emit('input', $event)" :minlength="minlength">
    <n-button slot="append" @click.native="show_password = !show_password" icon flat>
      <n-icon v-if="show_password">visibility_off</n-icon>
      <n-icon v-else>visibility</n-icon>
    </n-button>
    <slot name="label" slot="label" slot-scope="{label}" :label="label"></slot> <!-- forward label slot content to <n-input>'s label slot -->
    <slot name="prepend" slot="prepend"></slot> <!-- forward prepend slot content to <n-input>'s prepend slot -->
    <slot name="append" slot="append"></slot> <!-- forward prepend slot content to <n-input>'s prepend slot -->
    <slot name="help" slot="help"></slot> <!-- forward help slot content to <n-input>'s help slot -->
    <slot name="default" slot="default"></slot> <!-- forward default slot content to <n-input>'s default slot -->
  </n-input>
</template>

<script>
  export default {

    props: {
      value: { required: true },
      minlength: { type: Number, default: 6 },
    },

    data() {
      return {
        show_password: false,
      }
    },

    computed: {
      type() {
        return this.show_password ? 'text' : 'password'
      }
    },
  }
</script>